'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".SelectList-module_selectList__uWsft{display:flex;flex-direction:column;gap:8px;width:100%}.SelectList-module_selectListOption__ioQlb{flex-grow:1;font-size:14px;font-weight:inherit;margin:0;padding:.875rem 1rem;text-align:left}";
var styles = {"selectList":"SelectList-module_selectList__uWsft","selectListOption":"SelectList-module_selectListOption__ioQlb"};
styleInject["default"](css_248z, '5d1e777f-c5fe-441c-a527-edf4c696d519');

exports["default"] = styles;
